var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7486,
    cy: 16.7486,
    r: 16.7486,
    fill: "#E3E1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.375C14.4568 7.40568 12.0265 8.42959 10.228 10.228C8.42959 12.0265 7.40568 14.4568 7.375 17C7.40568 19.5432 8.42959 21.9735 10.228 23.772C12.0265 25.5704 14.4568 26.5943 17 26.625C19.5432 26.5943 21.9735 25.5704 23.772 23.772C25.5704 21.9735 26.5943 19.5432 26.625 17C26.5943 14.4568 25.5704 12.0265 23.772 10.228C21.9735 8.42959 19.5432 7.40568 17 7.375ZM22.5 17.6875H17.6875V22.5H16.3125V17.6875H11.5V16.3125H16.3125V11.5H17.6875V16.3125H22.5V17.6875Z",
    fill: "#7269EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAction);
export default __webpack_public_path__ + "static/media/add-action.fbe4820a8720fd2c603511b03c25c671.svg";
export { ForwardRef as ReactComponent };